import { useQuery } from '@tanstack/react-query'
import { pathOr, applySpec, pipe } from 'ramda'
import { round, toInteger } from 'lodash'
import { useQuery as gqlQuery, gql } from '@apollo/client'
import client from '@/ports/api-client'

const getApplications = async (listingId: string) => {
  try {
    return await client.get(`/listings/${listingId}/applications`, {
      noLoading: true
    })
  } catch (error) {
    throw error
  }
}

const AVG_RENTAL = gql`
  query avgRentalPrice($listingId: Int) {
    listingDetail(id: $listingId) {
      metadata {
        avg_price
        difference
      }
    }
  }
`

const useGetInsights = (listingId: string) => {
  const { data: avgPrice } = gqlQuery(AVG_RENTAL, {
    variables: {
      listingId: toInteger(listingId)
    }
  })

  const priceInfo = applySpec({
    difference: ({ difference }) => {
      const MAX = 999
      return pipe(
        Math.abs,
        diff => (!isNaN(diff) ? diff : 0),
        diff => round(parseFloat(diff.toPrecision(4)), 2),
        diff => (diff > MAX ? `+${MAX}` : diff)
      )(difference)
    },
    average: ({ avg_price }) => round(avg_price, 2) || '',
    aboveAverage: ({ difference }) => difference > 0
  })(pathOr({}, ['listingDetail', 'metadata'], avgPrice))

  const { data: applications } = useQuery({
    queryKey: [`applications`],
    queryFn: () => getApplications(listingId),
    refetchOnWindowFocus: false
  })

  return { applications, priceInfo }
}

export default useGetInsights
